import Vue from 'vue'
import VueRouter from 'vue-router'
import VueCookies from 'vue-cookies'
import Layout from '@/layout'
import store from '@/store'
import HomeView from '../views/HomeView.vue'
import login from '../views/login.vue'
import register from '../views/register.vue'
import agree from '../views/agree.vue'
import forget from '../views/forget.vue'
import catelist from '../views/catelist.vue'
import search from '../views/search.vue'
import goodsinfo from '../views/goodsinfo.vue'
import cart from '../views/cart.vue'
import submit from '../views/submit.vue'
import pay from '../views/pay.vue'
import orderinfo from '../views/orderinfo.vue'
import centerindex from '../views/centerindex.vue'
import coupon from '../views/coupon.vue'
import usercoupon from '../views/usercoupon.vue'
import userquestion from '../views/userquestion.vue'
import useraddress from '../views/useraddress.vue'
import userorder from '../views/userorder.vue'
import userrefund from '../views/userrefund.vue'
import usersetting from '../views/usersetting.vue'
import updatepwd from '../views/updatepwd.vue'
import updatephone from '../views/updatephone.vue'
import exportorder from '../views/exportorder.vue'
import userrefundlist from '../views/userrefundlist.vue'
import userrefundinfo from '../views/userrefundinfo.vue'
import batchpay from '../views/batchpay.vue'
import useraccount from '../views/useraccount.vue'
import userscore from '../views/userscore.vue'
import usermessage from '../views/usermessage.vue'
import usermessageinfo from '../views/usermessageinfo.vue'

import news from '../views/news.vue'
import newsinfo from '../views/newsinfo.vue'





Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}


const routes = [
  {
    path: '/login',
    name: 'login',
    component: login
  },
  {
    path: '/',
    component: Layout,
    hidden: true,
    children: [
  		{
  			path: '/',
  			name:"index",
  			component: HomeView
  		},
  		{path: '/register',name:"register",component: register},
  		{path: '/agree',name:"agree",component: agree},
  		{path: '/forget',name:"forget",component: forget},
  		{path: '/news',name:"news",component: news},
  		{path: '/newsinfo',name:"newsinfo",component: newsinfo},
  		{path: '/catelist',name:"catelist",component: catelist},
  		{path: '/search',name:"search",component: search},
  		{path: '/goodsinfo',name:"goodsinfo",component: goodsinfo},
  		{path: '/cart',name:"centerCart",component: cart},
  		{path: '/submit',name:"centerSubmit",component: submit},
  		{path: '/pay',name:"centerPay",component: pay},
  		{path: '/coupon',name:"centerCoupon",component: coupon},
  		{path: '/orderinfo',name:"centerOrderinfo",component: orderinfo},
  		{path: '/centerindex',name:"centerindex",component: centerindex},
  		{path: '/usercoupon',name:"centerusercoupon",component: usercoupon},
  		{path: '/userquestion',name:"centeruserquestion",component: userquestion},
  		{path: '/useraddress',name:"centeruseraddress",component: useraddress},
  		{path: '/userorder',name:"centeruserorder",component: userorder},
  		{path: '/userrefund',name:"centeruserrefund",component: userrefund},
  		{path: '/usersetting',name:"centerusersetting",component: usersetting},
  		{path: '/updatepwd',name:"centerupdatepwd",component: updatepwd},
  		{path: '/userrefundlist',name:"centeruserrefundlist",component: userrefundlist},
  		{path: '/userrefundinfo',name:"centeruserrefundinfo",component: userrefundinfo},
  		{path: '/updatephone',name:"centerupdatephone",component: updatephone},
  		{path: '/exportorder',name:"centerexportorder",component: exportorder},
  		{path: '/useraccount',name:"centeruseraccount",component: useraccount},
  		{path: '/batchpay',name:"centerbatchpay",component: batchpay},
  		{path: '/userscore',name:"centeruserscore",component: userscore},
  		{path: '/usermessage',name:"centerusermessage",component: usermessage},
  		{path: '/usermessageinfo',name:"centerusermessageinfo",component: usermessageinfo}
		
		
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


router.beforeEach(async (to, from, next) => {
	if(to.name.indexOf("center") > -1){
		const token = VueCookies.get('userToken');
		if (token && token !== 'undefined') {
			next()
		} else {
			// 没有登录的时候跳转到登录界面
			// 携带上登陆成功之后需要跳转的页面完整路径
			next({
				name: 'login'
			})
		}
	}else{
		next()
	}
})


export default router
